import { render } from "./Card.vue?vue&type=template&id=3772e3dd&scoped=true"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=3772e3dd&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3772e3dd"]])

export default __exports__